module.exports = __webpack_public_path__ + "images/emoji/paperclip.1fef0b4dd52fc60dba89.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/paperclip.png
// module id = DBIN
// module chunks = 1